import type { AnalyticsRendering } from '@analytics/models';

/**
 * Parses the CMS rendering to determine a name, checks the following:
 * - 'componentName' field value: this field value commonly represents the name of the analytics event.
 * - 'componentName' rendering value: this represents the *type* of element, as fallback.
 * - fallback to 'unknown'.
 *
 * @param rendering CMS component rendering
 * @returns string representing the name of a CMS component
 */
export function getComponentNameFromAnalyticsRendering(
  rendering: AnalyticsRendering | undefined
) {
  // Try to use the 'field value' from the sitecore rendering.
  const fieldValue = rendering?.fields?.componentName?.value;

  if (fieldValue && typeof fieldValue === 'string') {
    return fieldValue;
  }

  // Try to use the 'componentName' value.
  const componentName = rendering?.componentName;
  if (componentName && typeof componentName === 'string') {
    return componentName;
  }

  return 'unknown';
}
